/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CtmsItemRespVo
 */
export interface CtmsItemRespVo {
    /**
     * 主键 ID
     * @type {number}
     * @memberof CtmsItemRespVo
     */
    id?: number;
    /**
     * 通关项目分类id
     * @type {number}
     * @memberof CtmsItemRespVo
     */
    ctmsCategoryId?: number;
    /**
     * 通关项目分类名称
     * @type {string}
     * @memberof CtmsItemRespVo
     */
    ctmsCategoryName?: string;
    /**
     * 通关项目分类名称(英文)
     * @type {string}
     * @memberof CtmsItemRespVo
     */
    ctmsCategoryNameEn?: string;
    /**
     * 通关项目分类名称(中文)
     * @type {string}
     * @memberof CtmsItemRespVo
     */
    ctmsCategoryNameCn?: string;
    /**
     * HS 编码
     * @type {string}
     * @memberof CtmsItemRespVo
     */
    hsCode?: string;
    /**
     * 商品名称
     * @type {string}
     * @memberof CtmsItemRespVo
     */
    itemName?: string;
    /**
     * 商品名称（英文）
     * @type {string}
     * @memberof CtmsItemRespVo
     */
    itemNameEn?: string;
    /**
     * 商品名称（中文）
     * @type {string}
     * @memberof CtmsItemRespVo
     */
    itemNameCn?: string;
    /**
     * 关税税率
     * @type {number}
     * @memberof CtmsItemRespVo
     */
    taxRate?: number;
    /**
     * 增值税税率
     * @type {number}
     * @memberof CtmsItemRespVo
     */
    vatRate?: number;
    /**
     * 是否列表通关  0 不是， 1 是
     * @type {number}
     * @memberof CtmsItemRespVo
     */
    list?: number;
    /**
     * 是否可用 0 不可用，1 可用
     * @type {number}
     * @memberof CtmsItemRespVo
     */
    enable?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof CtmsItemRespVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof CtmsItemRespVo
     */
    updateTime?: string;
    /**
     * 是否需要kc认证，0 不需要， 1 需要
     * @type {number}
     * @memberof CtmsItemRespVo
     */
    kcCertification?: number;
}

/**
 * Check if a given object implements the CtmsItemRespVo interface.
 */
export function instanceOfCtmsItemRespVo(value: object): value is CtmsItemRespVo {
    return true;
}

export function CtmsItemRespVoFromJSON(json: any): CtmsItemRespVo {
    return CtmsItemRespVoFromJSONTyped(json, false);
}

export function CtmsItemRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CtmsItemRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'ctmsCategoryId': json['ctmsCategoryId'] == null ? undefined : json['ctmsCategoryId'],
        'ctmsCategoryName': json['ctmsCategoryName'] == null ? undefined : json['ctmsCategoryName'],
        'ctmsCategoryNameEn': json['ctmsCategoryNameEn'] == null ? undefined : json['ctmsCategoryNameEn'],
        'ctmsCategoryNameCn': json['ctmsCategoryNameCn'] == null ? undefined : json['ctmsCategoryNameCn'],
        'hsCode': json['hsCode'] == null ? undefined : json['hsCode'],
        'itemName': json['itemName'] == null ? undefined : json['itemName'],
        'itemNameEn': json['itemNameEn'] == null ? undefined : json['itemNameEn'],
        'itemNameCn': json['itemNameCn'] == null ? undefined : json['itemNameCn'],
        'taxRate': json['taxRate'] == null ? undefined : json['taxRate'],
        'vatRate': json['vatRate'] == null ? undefined : json['vatRate'],
        'list': json['list'] == null ? undefined : json['list'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
        'kcCertification': json['kcCertification'] == null ? undefined : json['kcCertification'],
    };
}

export function CtmsItemRespVoToJSON(json: any): CtmsItemRespVo {
    return CtmsItemRespVoToJSONTyped(json, false);
}

export function CtmsItemRespVoToJSONTyped(value?: CtmsItemRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'ctmsCategoryId': value['ctmsCategoryId'],
        'ctmsCategoryName': value['ctmsCategoryName'],
        'ctmsCategoryNameEn': value['ctmsCategoryNameEn'],
        'ctmsCategoryNameCn': value['ctmsCategoryNameCn'],
        'hsCode': value['hsCode'],
        'itemName': value['itemName'],
        'itemNameEn': value['itemNameEn'],
        'itemNameCn': value['itemNameCn'],
        'taxRate': value['taxRate'],
        'vatRate': value['vatRate'],
        'list': value['list'],
        'enable': value['enable'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
        'kcCertification': value['kcCertification'],
    };
}

